namespace SPA
{
	export namespace Guide
	{
		export class GuidePanel extends ui.base.BaseHTMLElement
		{

			private m_Guides:	GuideItem[];
			private m_Active: number;

			public constructor( private m_Content: ui.base.BaseHTMLElement )
			{
				super( 'guide-panel' );

				this.m_Guides	= new Array();
				this.addClass('hidden-xs');
				this.css(
					{
						'min-height': '150px',
						'border': '1px solid #e3e3e3',
						'border-radius': '4px'
					}
				);

				this.m_Active = 0;
			}

			public next(): boolean
			{
				return ( this.m_Active + 1 ) < this.m_Guides.length;
			}

			public prev(): boolean
			{
				return ( this.m_Active - 1 ) > 0;
			}

			public MoveNext(): boolean
			{
				return this.moveTo( this.m_Active + 1 );
			}

			public MovePrev(): boolean
			{
				return this.moveTo( this.m_Active - 1 );
			}

			public moveTo( index: number ): boolean
			{
				if ( index < 0 || index >= this.m_Guides.length )
				{
					return false;
				}

				this.m_Guides[ this.m_Active ].hide();
				this.m_Guides[ this.m_Active ].remClass( 'active' );

				this.m_Active = index;

				this.m_Guides[ this.m_Active ].addClass( 'active' );
				this.m_Guides[ this.m_Active ].show( this.m_Content );

				return true;
			}

			public rebuild( root: ui.base.BaseHTMLElement ): GuidePanel
			{
				this.empty();
				this.remove();

				this.appendTo( root );

				this.m_Guides.forEach(
					( item: GuideItem, index: number ): void =>
					{
						item.rebuild( this );

						if ( index === this.m_Active )
						{
							item.addClass( 'active' );
						}
						else
						{
							item.remClass( 'active' );
						}
					}
				);

				return this;
			}

			public addItem( item: GuideItem ): GuidePanel
			{
				item.setPanel( this, this.m_Guides.length );

				this.m_Guides.push( item );

				return this;
			}

		}
	}
}
